/* eslint-disable max-len */

export default {
  TAGS_MANAGE_OPEN: 'TAGS_MANAGE_OPEN',
  TAGS_MANAGE_CLOSE: 'TAGS_MANAGE_CLOSE',
  CONFIRMATION_MODAL_CLOSE: ' CONFIRMATION_MODAL_CLOSE',
  CONFIRMATION_MODAL_OPEN: ' CONFIRMATION_MODAL_OPEN',
  UI_NOTIFICATION_POPUP_ADD_NOTIFICATION: 'UI_NOTIFICATION_POPUP_ADD_NOTIFICATION',
  UI_NOTIFICATION_POPUP_ADD_CUSTOM_NOTIFICATION: 'UI_NOTIFICATION_POPUP_ADD_CUSTOM_NOTIFICATION',
  UI_NOTIFICATION_POPUP_REMOVE_NOTIFICATION: 'UI_NOTIFICATION_POPUP_REMOVE_NOTIFICATION',
  PROJECT_CREATE: 'PROJECT_CREATE',
  PROJECT_CREATE_SUCCESS: 'PROJECT_CREATE_SUCCESS',
  PROJECT_CREATE_FAIL: 'PROJECT_CREATE_FAIL',
  PROJECT_DELETE: 'PROJECT_DELETE',
  PROJECT_DELETE_SUCCESS: 'PROJECT_DELETE_SUCCESS',
  PROJECT_DELETE_FAIL: 'PROJECT_DELETE_FAIL',
  SET_DEFAULT_ORGANIZATION_NAME: 'SET_DEFAULT_ORGANIZATION_NAME',
  PUBLIC_USER_FETCH: 'PUBLIC_USER_FETCH',
  PUBLIC_USER_FETCH_SUCCESS: 'PUBLIC_USER_FETCH_SUCCESS',
  PUBLIC_USER_FETCH_FAIL: 'PUBLIC_USER_FETCH_FAIL',
  NOTIFICATIONS_FETCH: 'NOTIFICATIONS_FETCH',
  NOTIFICATIONS_FETCH_SUCCESS: 'NOTIFICATIONS_FETCH_SUCCESS',
  NOTIFICATIONS_FETCH_FAIL: 'NOTIFICATIONS_FETCH_FAIL',
  NOTIFICATIONS_UNREAD_COUNT_FETCH: 'NOTIFICATIONS_UNREAD_COUNT_FETCH',
  NOTIFICATIONS_UNREAD_COUNT_FETCH_SUCCESS: 'NOTIFICATIONS_UNREAD_COUNT_FETCH_SUCCESS',
  NOTIFICATIONS_UNREAD_COUNT_FETCH_FAIL: 'NOTIFICATIONS_UNREAD_COUNT_FETCH_FAIL',
  NOTIFICATIONS_NOTIFICATION_MARK_READ_REQUEST: 'NOTIFICATIONS_NOTIFICATION_MARK_READ_REQUEST',
  NOTIFICATIONS_NOTIFICATION_MARK_READ_SUCCESS: 'NOTIFICATIONS_NOTIFICATION_MARK_READ_SUCCESS',
  NOTIFICATIONS_NOTIFICATION_MARK_READ_FAIL: 'NOTIFICATIONS_NOTIFICATION_MARK_READ_FAIL',
  NOTIFICATIONS_MARK_ALL_READ_REQUEST: 'NOTIFICATIONS_MARK_ALL_READ_REQUEST',
  NOTIFICATIONS_MARK_ALL_READ_SUCCESS: 'NOTIFICATIONS_MARK_ALL_READ_SUCCESS',
  NOTIFICATIONS_MARK_ALL_READ_FAILURE: 'NOTIFICATIONS_MARK_ALL_READ_FAILURE',
  NOTIFICATIONS_ADD_ORGANIZATIONS_SUCCESS: 'NOTIFICATIONS_ADD_ORGANIZATIONS_SUCCESS',
};
